import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

const FeaturedCard = ({ item }) => {
  return (
    <div className="col-12 col-md-4 mb-4">
        <div className="card h-100">
            {item.isNew === 1 ? <span className="newMark bg-dark">New</span> : <></>}
            <Link to={`/product/${item.title_slug}`}>
                <img src={process.env.REACT_APP_UPLOAD_URL + item.img[0]?.image} alt={item.title} className="card-img-top" />
            </Link>
            <div className="card-body">
                <Link to={`/product/${item.title_slug}`} className="text-decoration-none text-dark">{item.title}</Link>
                {/*<p className="card-text">
                    {item.description.length > 50 ? 
                    <ReactMarkdown>{item.description.substring(0, 49) + "..."}</ReactMarkdown> : 
                    <ReactMarkdown>{item.description}</ReactMarkdown> }
                </p>*/}
                <p className="text-center mb-0 mt-3">₹ {item.price}</p>
            </div>
        </div>
    </div>
  );
};

export default FeaturedCard;
